import { GlobalApi } from './globalApi';

const globalApi = new GlobalApi();

export { globalApi };
